/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Schema for sending back 409 Conflicts when a user confirmation is required.
 * @export
 * @interface ConfirmationErrorSchema
 */
export interface ConfirmationErrorSchema {
    /**
     * 
     * @type {string}
     * @memberof ConfirmationErrorSchema
     */
    detail: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmationErrorSchema
     */
    actionRequired: ConfirmationErrorSchemaActionRequiredEnum;
}


/**
 * @export
 */
export const ConfirmationErrorSchemaActionRequiredEnum = {
    Confirm: 'confirm',
    Retry: 'retry'
} as const;
export type ConfirmationErrorSchemaActionRequiredEnum = typeof ConfirmationErrorSchemaActionRequiredEnum[keyof typeof ConfirmationErrorSchemaActionRequiredEnum];


/**
 * Check if a given object implements the ConfirmationErrorSchema interface.
 */
export function instanceOfConfirmationErrorSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "detail" in value;
    isInstance = isInstance && "actionRequired" in value;

    return isInstance;
}

export function ConfirmationErrorSchemaFromJSON(json: any): ConfirmationErrorSchema {
    return ConfirmationErrorSchemaFromJSONTyped(json, false);
}

export function ConfirmationErrorSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmationErrorSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'detail': json['detail'],
        'actionRequired': json['action_required'],
    };
}

export function ConfirmationErrorSchemaToJSON(value?: ConfirmationErrorSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'detail': value.detail,
        'action_required': value.actionRequired,
    };
}

